module.exports = "<div class=\"row\">\n    <h2 class=\"pull-left\">Account Management</h2>\n    <div class=\"action-container pull-right\">\n        <button type=\"button\" class=\"btn btn-success\" routerLink=\"/create-account\" *ngIf=\"isAdmin()\">+ Add Account</button>\n    </div>\n</div>\n\n<account-list></account-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/accounts/accounts.html
// module id = ./src/app/components/accounts/accounts.html
// module chunks = main